import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import TabPanel from '@mui/lab/TabPanel';
import Button from '@mui/material/Button';
import SearchBar from "@mkyy/mui-search-bar";
import { toast } from "react-toastify";
import GroupProductTable from '../../../common/Tables/GroupProductTable';
import { publicAPI, privateAPI } from '../../../utils/api';
import CreateEditProductDialog from '../../../common/Dialogs/CreateEditProduct';
import { MuiButtonWrapper } from '../styles';
import '../../../styles.css';

const AdminProducts = () => {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState();
  const [rows, setRows] = useState();
  const [createProductOpen, setCreateProductOpen] = useState(false);
  const [productDTO, setProductDTO] = useState({})

  const requestSearch = (searchedVal) => {
    const filteredRows = products.filter((row) => {
      return row.name.toLowerCase().includes(searchedVal.toLowerCase());
    });
    filteredRows.length > 0 ? setRows(filteredRows) : setRows([{id: 'No data', name: 'No data', description: 'No data', image: 'No data'}])
  };

  const closeCreateProductDialog = () => {
    setProductDTO({});
    setCreateProductOpen(false);
  }

  const getAllProducts = async () => {
    try{
      setLoading(true);
      const response = await privateAPI.get(`auth/bacchus/admin/product`);
      setProducts(response.data);
      setRows(response.data);
      setLoading(false);
    } catch (error){
      setLoading(false);
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const deleteProduct = async (id) => {
    try{
      setLoading(true);
      await privateAPI.delete(`/auth/bacchus/admin/product/${id}`);
      getAllProducts();
      setLoading(false);
      toast.success('Product is deleted');
    } catch (error){
      setLoading(false);
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const crateNewProduct = async () => {
    if(!productDTO.productGroupId) return toast.info('Choose a group!');
    if(!productDTO.name) return toast.info('Name is required');
    if(!productDTO.description) return toast.info('Description is required');
    if(!productDTO.image) return toast.info('Image is required');

    try{
      setLoading(true);
      productDTO.image = productDTO.image ?? [];
      await privateAPI.post(`/auth/bacchus/admin/product`, productDTO);
      getAllProducts();
      setProductDTO({});
      setCreateProductOpen(false);
      setLoading(false);
    } catch (error){
      setLoading(false);
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const openEditProduct = async (id) => {
    try {
      const response = await publicAPI.get(`/public/bacchus/product/${id}`);
      setProductDTO(response.data)
      setCreateProductOpen(true)
    } catch (error){
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const editProduct = async (close) => {
    if(!productDTO.productGroupId) return toast.info('Choose a group!');
    if(!productDTO.name) return toast.info('Name is required');
    if(!productDTO.description) return toast.info('Description is required');
    if(!productDTO.image) return toast.info('Image is required');

    try {
      setLoading(true);
      productDTO.image = productDTO.image ?? [];
      await privateAPI.put(`/auth/bacchus/admin/product/${productDTO.id}`, productDTO);
      getAllProducts();
      setProductDTO({});
      setCreateProductOpen(false);
      setLoading(false);
    } catch (error){
      setLoading(false);
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  useEffect(() => {
    getAllProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setLoading(false)
  }, []);

  return (
    <TabPanel value="2">
      <MuiButtonWrapper>
        <Button 
          variant="outlined" 
          className="shadow-on-elements first-button"
          onClick={() => setCreateProductOpen(true)}
          >
            Add New Product
        </Button>
        <Button 
          variant="outlined" 
          className="shadow-on-elements"
          onClick={() => getAllProducts()}
          >
            Reload Products
        </Button>
      </MuiButtonWrapper>
      <SearchBar
        onChange={(searchVal) => requestSearch(searchVal)}
        className="shadow-on-elements"
        style={{ marginBottom: '30px', border: '1px solid #001753' }}
        />
      <GroupProductTable 
        items={rows}
        deleteProduct={deleteProduct}
        openEditProduct={openEditProduct}
        editProduct={editProduct}
        setProductDTO={setProductDTO}
        productDTO={productDTO}
        />
      <CreateEditProductDialog 
        open={createProductOpen}
        closeCreateProductDialog={closeCreateProductDialog}
        crateNewProduct={crateNewProduct}
        setProductDTO={setProductDTO}
        productDTO={productDTO}
        editProduct={editProduct}
        />
      <Backdrop
        sx={{ color: '#fff', zIndex: 1000 }}
        open={loading}
        >
          <CircularProgress color="inherit" />
      </Backdrop>
    </TabPanel>
  );
};

export default AdminProducts;